// Generated by Copilot
export const ORDER_STATUS = {
    Draft: 'Draft',
    Submitted: 'Submitted',
    Paid: 'Paid',
    Started: 'Started',
    Prepared: 'Prepared',
    Ready: 'Ready',
    Completed: 'Completed',
    Trashed: 'Trashed',
    Cancelled: 'Cancelled',
} as const;
export type OrderStatus = (typeof ORDER_STATUS)[keyof typeof ORDER_STATUS];

export const ORDER_ITEM_STATUS = {
    Pending: 'Pending',
    Complete: 'Complete',
    NotAvailable: 'NotAvailable',
    Returned: 'Returned',
    Missing: 'Missing',
    Trashed: 'Trashed',
} as const;
export type OrderItemStatus =
    (typeof ORDER_ITEM_STATUS)[keyof typeof ORDER_ITEM_STATUS];

export const ORDER_PAYMENT_ADJUSTMENT_TYPE = {
    CustomerCancellation: 'CustomerCancellation',
    KioskAdjustment: 'KioskAdjustment',
    KioskCancellation: 'KioskCancellation',
    Auto86Adjustment: 'Auto86Adjustment',
    Auto86Cancellation: 'Auto86Cancellation',
} as const;
export type OrderPaymentAdjustmentType =
    (typeof ORDER_PAYMENT_ADJUSTMENT_TYPE)[keyof typeof ORDER_PAYMENT_ADJUSTMENT_TYPE];

export const ORDER_PAYMENT_ADJUSTMENT_STATUS = {
    Succeeded: 'Succeeded',
    Failed: 'Failed',
    Skipped: 'Skipped',
} as const;
export type OrderPaymentAdjustmentStatus =
    (typeof ORDER_PAYMENT_ADJUSTMENT_STATUS)[keyof typeof ORDER_PAYMENT_ADJUSTMENT_STATUS];

export const ORDER_ITEM_TYPE = {
    StandardDrink: 'StandardDrink',
    CustomDrink: 'CustomDrink',
    Product: 'Product',
} as const;
export type OrderItemType =
    (typeof ORDER_ITEM_TYPE)[keyof typeof ORDER_ITEM_TYPE];

export const PICKUP_FACE_VERIFICATION_STATUS = {
    Pending: 'Pending',
    Passed: 'Passed',
    Failed: 'Failed',
    Overridden: 'Overridden',
} as const;

export type PickupFaceVerificationStatus =
    (typeof PICKUP_FACE_VERIFICATION_STATUS)[keyof typeof PICKUP_FACE_VERIFICATION_STATUS];
